export const PRESET_TYPE = {
  unassigned: 1,
};
